import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import usePullToRefresh from '../../hooks/usePullToRefresh';

const THRESHOLD = 80;

const PullToRefresh: React.FC = function PullToRefresh() {
  const { pullDistance, refreshing } = usePullToRefresh();

  if (pullDistance === 0 && !refreshing) return null;

  const progress = Math.min((pullDistance / THRESHOLD) * 100, 100);
  const ready = pullDistance >= THRESHOLD;

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        left: 0,
        position: 'fixed',
        right: 0,
        top: 0,
        transform: `translateY(${pullDistance - 40}px)`,
        transition: refreshing ? 'none' : 'transform 0.1s ease-out',
        zIndex: 9998
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          background: '#fff',
          borderRadius: '50%',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          display: 'flex',
          height: 36,
          justifyContent: 'center',
          width: 36
        }}
      >
        {refreshing ? (
          <CircularProgress size={20} sx={{ color: '#005DA2' }} />
        ) : (
          <CircularProgress
            size={20}
            sx={{
              color: ready ? '#005DA2' : '#CBCCD3',
              transform: `rotate(${progress * 3.6}deg)`,
              transition: 'color 0.15s'
            }}
            value={progress}
            variant="determinate"
          />
        )}
      </Box>
    </Box>
  );
};

export default PullToRefresh;
